import { Divider, Popover } from "@mui/material";
import React, { FC } from "react";
import { H4 } from "../../Typography";

// component props interface
interface PopoverLayoutProps {
  title: string | JSX.Element;
  hiddenViewButton?: boolean;
  popoverOpen: boolean;
  popoverClose: () => void;
  children: React.ReactNode;
  handleButton?: () => void;
  anchorRef: React.MutableRefObject<null>;
  minWidth?: number | string;
  maxWidth?: number | string;
}

const PopoverLayout: FC<PopoverLayoutProps> = (props) => {
  const {
    children,
    popoverClose,
    popoverOpen,
    anchorRef,
    title
  } = props;
  return (
    <Popover
      open={popoverOpen}
      onClose={popoverClose}
      anchorEl={anchorRef.current}
      anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
    >
      <H4 fontWeight="700" p={2}>
        {title || "Notifications"}
      </H4>
      <Divider />

      {children}

    </Popover>
  );
};

export default PopoverLayout;
